import React, { useRef } from 'react';
import {
	View,
	StyleSheet,
} from 'react-native';
import {
	TextInput,
	useTheme,
	Text,
} from 'react-native-paper';

export const CodeInput = ({ route, token, setToken }) => {
	const theme = useTheme();
	
	// Helper function to update a specific token field
	const updateToken = (field, value) => {
		setToken(prev => ({
			...prev,
			[field]: value
		}));
	};
	
	const codeRef2 = useRef();
	const codeRef3 = useRef();
	const codeRef4 = useRef();
	const codeRef5 = useRef();
	const codeRef6 = useRef();
	const codeRef1 = useRef();

	const CodeTextInput = ({ value, onChangeText, inputRef, contentStyle = {} }) => (
		<TextInput
			style={styles.codeInput}
			contentStyle={{ paddingRight:20, textAlign: 'center', fontSize: 36, fontWeight: 'bold', ...contentStyle }}
			keyboardType='number-pad'
			mode="outlined"
			ref={inputRef}
			value={value}
			caretHidden={true}
			onFocus={(e) => {
				const length = value?.length || 0;
				e.target.setSelection(length, length);
			}}
			onChangeText={onChangeText}
			disabled={!!route.params?.token}
		/>
	);

	const styles = StyleSheet.create({
		codeContainer: {
			display: 'flex',
			flexDirection: 'row',
			gap: 4,
		},
		codeInput: {
			flexGrow: 1,
			flexShrink: 1,
			minWidth: 0,
			minHeight: 0,
			textAlign: 'center',
		},
		outerCodeContainer: {
			display: 'flex',
			flexDirection: 'column',
			gap: 4
		},
		codeLabel: {
			fontSize: 16,
			color: theme.colors.accent,
		}
	});
	

	return (
		<View style={styles.outerCodeContainer}>
			<Text style={styles.codeLabel}>Enter confirmation code from email</Text>
			<View style={styles.codeContainer}>
				<CodeTextInput
					value={token.num1 || ''}
					inputRef={codeRef1}
					onChangeText={(val) => {
						if (val === '' && token.num1) {
						// Backspace was pressed - clear and stay focused
							updateToken('num1', '');
						} else if (val) {
							updateToken('num1', val[val.length - 1]);
							requestAnimationFrame(() => codeRef2.current?.focus());
						}
					}}
				/>
				<CodeTextInput
					value={token.num2}
					inputRef={codeRef2}
					onChangeText={(val) => {
						if (val === '' && token.num2) {
						// Backspace was pressed
							updateToken('num2', '');
							requestAnimationFrame(() => codeRef1.current?.focus());
						} else if (val) {
							updateToken('num2', val[val.length - 1]);
							requestAnimationFrame(() => codeRef3.current?.focus());
						}
					}}
				/>
				<CodeTextInput
					value={token.num3}
					inputRef={codeRef3}
					onChangeText={(val) => {
						if (val === '' && token.num3) {
						// Backspace was pressed
							updateToken('num3', '');
							requestAnimationFrame(() => codeRef2.current?.focus());
						} else if (val) {
							updateToken('num3', val[val.length - 1]);
							requestAnimationFrame(() => codeRef4.current?.focus());
						}
					}}
				/>
				<CodeTextInput
					value={token.num4}
					inputRef={codeRef4}
					onChangeText={(val) => {
						if (val === '' && token.num4) {
						// Backspace was pressed
							updateToken('num4', '');
							requestAnimationFrame(() => codeRef3.current?.focus());
						} else if (val) {
							updateToken('num4', val[val.length - 1]);
							requestAnimationFrame(() => codeRef5.current?.focus());
						}
					}}
				/>
				<CodeTextInput
					value={token.num5}
					inputRef={codeRef5}
					onChangeText={(val) => {
						if (val === '' && token.num5) {
						// Backspace was pressed
							updateToken('num5', '');
							requestAnimationFrame(() => codeRef4.current?.focus());
						} else if (val) {
							updateToken('num5', val[val.length - 1]);
							requestAnimationFrame(() => codeRef6.current?.focus());
						}
					}}
				/>
				<CodeTextInput
					value={token.num6}
					inputRef={codeRef6}
					onChangeText={(val) => {
						if (val === '' && token.num6) {
						// Backspace was pressed
							updateToken('num6', '');
							requestAnimationFrame(() => codeRef5.current?.focus());
						} else if (val) {
							updateToken('num6', val[val.length - 1]);
						// Stay focused on last input
						}
					}}
				/>
			</View>
		</View>
	);
};
